export const getFileExtension = (fileName) => {
  let extPattern = /\.[0-9a-z]+$/i;

  let matches = extPattern.exec(fileName);

  if (!Array.isArray(matches)) return '';

  let [extMatch] = matches;

  return extMatch.toLowerCase();
};
